module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    attrs: {
      "className": "captcha"
    }
  }, [_c('div', {
    attrs: {
      "className": "captcha-bg"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    attrs: {
      "className": "content-box",
      "id": "bindYp"
    }
  })])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0a784b2a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a784b2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Captcha/src/main.vue
// module id = 65
// module chunks = 1 3 4 5